<template>
  <div :class="['item-container', `background-img${backgroundId}`]">
    <div class="custom-card-title">{{ titleText }}</div>
    <slot name="button"></slot>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'

const TypingEssayLessonCard = Vue.extend({
  name: 'TypingEssayLessonCard',
  props: {
    backgroundId: {
      type: Number,
      required: true
    },
    titleText: {
      type: String,
      required: true
    }
  }
})

export default TypingEssayLessonCard
</script>

<style lang='scss' scoped>
@import '../styles/lessonCardStyles.scss';

// .item-container {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 150px;
//   height: 115px;
//   background-color: #fff;
//   border: 1px solid #e4e4e4;
//   border-radius: 38px;
//   background-size: cover;
// }

.background-img1 {
  background-image: url("../../../assets/Typing/LessonCardBackgrounds/background-type1.svg");
}

.background-img2 {
  background-image: url("../../../assets/Typing/LessonCardBackgrounds/background-type2.svg");
}
</style>
